import { useEffect, useState } from 'react';
import GaugeComponent from "react-gauge-component";
import BounceLoader from "react-spinners/BounceLoader";
import axios from 'axios';
import qs from 'qs';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import Access from "./Components/Access";
import Navbar from "./Components/Navbar";
import Gantt from "./Components/GanttComponent";
import Dialog from "./Components/Dialog";
import ModalPilotage from "./Components/ModalPilotage";
import { ReactComponent as Check } from './Img/icon-check.svg';
import { ReactComponent as Add } from './Img/icon-add.svg';
import { ReactComponent as Trash } from './Img/icon-trash.svg';
import { addSpace, rescueHtml } from "./Components/Tools";
import IncidencesFinancieresOperations from './Components/IncidencesFinancieresOperations';

const OperationPage = (props) => {
    const { id } = useParams();
    const location = useLocation();
    const isNewOperation = new URLSearchParams(location.search).get('new') === 'true';
    const [premierpassage, setPremierpassage] = useState(0);
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [operation, setOperation] = useState(null);
    const [modalites, setModalites] = useState([]);
    const [tauxAnnuel, setTauxAnnuel] = useState(null);
    const [modalite_portage_selectionnee, setModalite_portage_selectionnee] = useState(null);
    const [axes, setAxes] = useState([]);
    const [territoires, setTerritoires] = useState([]);
    const [clients, setClients] = useState([]);
    const [aff, setAff] = useState(false);
    const [details, setDetails] = useState(!isNewOperation);
    const [moyens, setMoyens] = useState(false);
    const [echeancier, setEcheancier] = useState(false);
    const [incidences, setIncidences] = useState(false);
    const [incidences_financieres, setIncidences_financieres] = useState({});
    const [evaluation, setEvaluation] = useState(false);
    const [pilotage, setPilotage] = useState(false);
    const [pilotage_operation, setPilotage_operation] = useState([]);
    const [modalPilotage, setModalPilotage] = useState(false);
    const [objetPilotage, setObjetPilotage] = useState(false);
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    const [pilotageLineSelected, setPilotageLineSelected] = useState(null);
    const [droits, setDroits] = useState(isNewOperation);
    const [users, setUsers] = useState([]);
    const [boolNom, setBoolNom] = useState(false);
    const [boolPrenom, setBoolPrenom] = useState(false);
    const [boolEmail, setBoolEmail] = useState(false);
    const [boolRang, setBoolRang] = useState(false);
    const [visualisation, setVisualisation] = useState(false);
    const [modification, setModification] = useState(false);
    const [canModify, setCanModify] = useState(false);
    const heightObject = window.innerHeight/1.9;

    const purple = '#6571FE';
    const blue = '#069BD3';
    const green = '#59B44A';
    const orange = '#FFA500';
    const red = '#FF0000';
    const greyChapter = '#DBDBDB';

    function compareNomAsc(a, b) {
        const nomA = a.nom ? a.nom.toUpperCase() : 0;
        const nomB = b.nom ? b.nom.toUpperCase() : 0;
        if (nomA < nomB) return -1;
        if (nomA > nomB) return 1;
        return 0;
    }

    function compareNomDes(a, b) {
        const nomA = a.nom ? a.nom.toUpperCase() : 0;
        const nomB = b.nom ? b.nom.toUpperCase() : 0;
        if (nomA > nomB) return -1;
        if (nomA < nomB) return 1;
        return 0;
    }

    function comparePrenomAsc(a, b) {
        const prenomA = a.prenom ? a.prenom.toUpperCase() : 0;
        const prenomB = b.prenom ? b.prenom.toUpperCase() : 0;
        if (prenomA < prenomB) return -1;
        if (prenomA > prenomB) return 1;
        return 0;
    }

    function comparePrenomDes(a, b) {
        const prenomA = a.prenom ? a.prenom.toUpperCase() : 0;
        const prenomB = b.prenom ? b.prenom.toUpperCase() : 0;
        if (prenomA > prenomB) return -1;
        if (prenomA < prenomB) return 1;
        return 0;
    }

    function compareEmailAsc(a, b) {
        const emailA = a.email ? a.email.toUpperCase() : 0;
        const emailB = b.email ? b.email.toUpperCase() : 0;
        if (emailA < emailB) return -1;
        if (emailA > emailB) return 1;
        return 0;
    }

    function compareEmailDes(a, b) {
        const emailA = a.email ? a.email.toUpperCase() : 0;
        const emailB = b.email ? b.email.toUpperCase() : 0;
        if (emailA > emailB) return -1;
        if (emailA < emailB) return 1;
        return 0;
    }

    function compareRangAsc(a, b) {
        return a.id_type_users - b.id_type_users;
    }

    function compareRangDes(a, b) {
        return b.id_type_users - a.id_type_users;
    }

    async function callbackDialog(ret) {
        if (ret === true) {
            await suppressLinePilotage();
        }
        else {
            await setPilotageLineSelected(null);
        }
    }

    async function suppressLinePilotage() {
        pilotage_operation.forEach((element, i) => {
            if (element[0] === pilotageLineSelected) {
                delete pilotage_operation[i];
            }
        });
        await setPilotageLineSelected(null);
    }

    async function addLinePilotage() {
        let date = new Date();
        let yyyy = date.getFullYear();
        let mm = date.getMonth() + 1;
        let dd = date.getDate();
        if (dd < 10) {
            dd = '0'+dd;
        }
        if (mm < 10) {
            mm = '0'+mm;
        }
        
        var tmp = [
            'tmp_'+pilotage_operation.length,//[0] id
            null,//                            [1] id_projet (null pour opération)
            id,//                              [2] id_operation
            yyyy+'-'+mm+'-'+dd,//              [3] date
            '',//                              [4] instance reunie
            '',//                              [5] releve decision
            '',//                              [6] action suivante
            '0000-00-00',//                    [7] date limite
            '',//                              [8] responsable action
            '',//                              [9] liste mails
            ''//                               [10] action terminee
        ];
        await pilotage_operation.push(tmp)
        await setAff(!aff);
    }

    useEffect(() => {
        if (props.user === null) {
            props.getUser();
        }
        else {
            if (premierpassage === 0) {
                mount();
                setPremierpassage(1);
            }
        }
    }, [props.user, incidences_financieres]);


    async function mount()
    {
        var operation_tmp = null;
        var modalite_portage_tmp = [];
        var modalite_portage_selectionnee_tmp = null;
        
        // Fetch operation
        try {
            const res = await axios.get('/api/operations.php?id=' + encodeURIComponent(id));
            if (res && res.data && res.data.status === 1 && res.data.data) {
                const operationData = res.data.data;
                
                // Vérification de sécurité : l'opération doit appartenir au budget de l'utilisateur
                if (props.user && props.user.id_budget && operationData.id_budget != props.user.id_budget) {
                    NotificationManager.error('Vous n\'avez pas accès à cette opération', '', 3000);
                    setTimeout(() => {
                        history.push('/operations');
                    }, 1500);
                    return;
                }
                operation_tmp = operationData;
                setOperation(operationData);
                
                // Vérifier les droits de modification de l'utilisateur
                if (operationData && props.user) {
                    // Les admins (id_type_user 1 ou 2) peuvent toujours modifier
                    if (props.user.id_type_users == '1' || props.user.id_type_users == '2') {
                        setCanModify(true);
                    } else {
                        // Les autres utilisateurs doivent avoir leur ID dans id_users_droits_modif
                        const droits_modif = (operationData.id_users_droits_modif || '').split(';').map(u => u.trim()).filter(u => u !== '');
                        setCanModify(droits_modif.includes(String(props.user.id)));
                    }
                } else {
                    setCanModify(false);
                }
            } else {
                NotificationManager.error((res && res.data && res.data.message) || 'Opération introuvable', '', 3000);
            }
        } catch (e) {
            console.error(e);
            NotificationManager.error('Erreur récupération opération', '', 3000);
        }

        // Fetch modalites
        if (props.user && props.user.id_organisme) {
            try {
                const rm = await axios.post('/api/modalites_portage.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
                if (rm && rm.data) {
                    const list = Array.isArray(rm.data) ? rm.data : (rm.data.data ? rm.data.data : []);
                    modalite_portage_tmp = list || [];
                    setModalites(list || []);
                } else setModalites([]);
            } catch (err) {
                console.warn(err);
                setModalites([]);
            }

            // Fetch axes
            try {
                const ra = await axios.post('/api/axes_interventions.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
                if (ra && ra.data) {
                    const list = Array.isArray(ra.data) ? ra.data : (ra.data.data ? ra.data.data : []);
                    setAxes(list || []);
                } else setAxes([]);
            } catch (err) {
                console.warn(err);
                setAxes([]);
            }
            
            // Fetch territoires
            try {
                const rt = await axios.post('/api/territoires.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
                if (rt && rt.data) {
                    const list = Array.isArray(rt.data) ? rt.data : (rt.data.data ? rt.data.data : []);
                    setTerritoires(list || []);
                } else setTerritoires([]);
            } catch (err) {
                console.warn(err);
                setTerritoires([]);
            }

            // Fetch clients
            try {
                const rc = await axios.post('/api/clients_epfl.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
                if (rc && rc.data) {
                    const list = Array.isArray(rc.data) ? rc.data : (rc.data.data ? rc.data.data : []);
                    setClients(list || []);
                } else setClients([]);
            } catch (err) {
                console.warn(err);
                setClients([]);
            }
        }

        // Fetch users
        try {
            const resUsers = await axios.post('/api/users.php', qs.stringify({getUsers: true, id_organisme: props.user.id_organisme}));
            if (resUsers && resUsers.data) {
                setUsers(resUsers.data);
            }
        } catch (e) {
            console.error(e);
        }

        // Fetch pilotage
        try {
            const rp = await axios.post('/api/pilotage_projet.php', qs.stringify({ get: true, id_operation: id }));
            if (rp && rp.data) {
                setPilotage_operation(rp.data);
            }
        } catch (err) {
            console.warn(err);
            setPilotage_operation([]);
        }

        // Fetch taux_annuel
        let tauxAnnuelData = null;
        try {
            const ta = await axios.post('/api/taux_annuel.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (ta && ta.data) {
                tauxAnnuelData = ta.data;
                setTauxAnnuel(ta.data);
            }
        }
        catch (err) {
            console.warn('Erreur lors du chargement du taux annuel:', err);
        }

        // Set modalite_portage_selectionnee
        modalite_portage_tmp.forEach(element => {
            if (element.id === operation_tmp.id_modalite_portage) {
                modalite_portage_selectionnee_tmp = element;
                setModalite_portage_selectionnee(element);
            }
        });

        // Fetch incidences financières
        await loadIncidencesFinancieres(id, operation_tmp, modalite_portage_selectionnee_tmp);
    }


    /**************** Load incidences financières ****************/

    async function loadIncidencesFinancieres(operationId, operation_tmp = null, modalite_portage_selectionnee_tmp = null)
    {
        const taux_frais = parseFloat(modalite_portage_selectionnee_tmp ? modalite_portage_selectionnee_tmp.taux : 0);
        try {
            // Création du tableau incidences financieres initialisé à 0
            var tmp = [];
            // Parcour des annees
            if (operation_tmp && operation_tmp.duree_portage
                && operation_tmp.date_premiere_acquisition
                && operation_tmp.date_premiere_facturation)
            {
                const DP = parseInt(operation_tmp.duree_portage);
                const yearAcquisition = new Date(operation_tmp.date_premiere_acquisition).getFullYear();
                const yearFirstFacturation = new Date(operation_tmp.date_premiere_facturation).getFullYear();
                const yearFirstFacturationIdx = yearFirstFacturation - yearAcquisition;
                const nbAnnees = yearFirstFacturationIdx + DP;
                for (let i = 0; i < nbAnnees; i++) {
                    const year = yearAcquisition + i;
                    tmp[year] = {
                        prix_acquisition: 0,
                        frais_actes: 0,
                        subventions: 0,
                        retrocessions: 0,
                        total_annuel_capital_porte: 0,
                        frais_prealables: 0,
                        frais_annexes: 0,
                        frais_gegr: 0,
                        frais_proto_amenagement: 0,
                        total_annuel_hors_capital_porte: 0,
                        tva_versee: 0,
                        tva_recue: 0,
                        depots_cautionnements_verses: 0,
                        depots_cautionnements_recus: 0,
                        annuite_capital_porte: 0,
                        annuite_capital_porte_reel: 0,
                        annuite_hors_capital_porte: 0,
                        annuite_hors_capital_porte_reel: 0,
                        annuite_definitive: 0,
                        total_capital_stocke: 0,
                        total_capital_porte: 0,
                        taux_applicable_capital: taux_frais,
                        frais_portage_ht: 0,
                        tva_frais_portage: 0,
                        frais_portage_ttc: 0,
                        entretien_reparations: 0,
                        eau_electricite: 0,
                        charges_copropriete: 0,
                        taxes_foncieres: 0,
                        taxe_redevance_om: 0,
                        assurances: 0,
                        autres_depenses: 0,
                        total_depenses: 0,
                        loyers_percus: 0,
                        refacturation_eau_electricite: 0,
                        refacturation_charges_copropriete: 0,
                        refacturation_taxes_foncieres: 0,
                        refacturation_om: 0,
                        refacturation_assurances: 0,
                        autres_recettes: 0,
                        total_recettes: 0,
                        solde_annuel_frais_gestion: 0,
                        solde_cumule_frais_gestion: 0,
                        solde_operation: 0,
                        taux_interet_moy_annuel: 0,
                        taux_portage: 0
                    };
                }
            }

            // Récupérer les incidences financières de l'opération en BDD
            const response = await axios.post('/api/incidences_financieres_operations.php', qs.stringify({
                action: 'get_by_operation',
                id_operation: operationId
            }));
            
            if (response && response.data && response.data.status === 1) {
                const incidencesData = response.data.data || [];
                // Parcour de tmp pour remplir avec les données de la BDD (en matchant par année) sauf pour taux_applicable_capital s'il n'y a pas de valeur
                for (const index in tmp) {
                    const incidenceForYear = incidencesData.find(inc => parseInt(inc.annee) === parseInt(index));
                    if (incidenceForYear) {
                        // Convertir les valeurs null en 0 et convertir en float
                        const cleanedData = {};
                        Object.keys(incidenceForYear).forEach(key => {
                            cleanedData[key] = incidenceForYear[key] === null ? 0 : parseFloat(incidenceForYear[key]) || 0;
                        });
                        tmp[index] = { ...tmp[index], ...cleanedData };
                    }
                }
            }
            setIncidences_financieres(tmp);
            setAff(!aff);
        } catch (err) {
            console.warn('Erreur lors du chargement des incidences financières:', err);
        }
    }

    async function recalculateProspective()
    {
        try {
            const params = {
                action: 'recalculate_prospective',
                id_budget: props.user.id_budget,
                prosp_an_deb: props.user.config_budget.prosp_an_deb,
                prosp_an_fin: props.user.config_budget.prosp_an_fin
            };
            return await axios.post('/api/incidences_financieres_operations.php', qs.stringify(params))
            .then((response) => {
                if (!response.data || response.data.status !== 1) {
                    setLoading(false);
                    setDetails(true);
                    throw new Error(response.data?.message || 'Erreur lors du recalcul des prospectives');
                }
                else {
                    NotificationManager.success('Opération mise à jour', '', 2000);
                    return true;
                }
            })
            .catch((error) => {
                console.warn('Erreur lors du recalcul des prospectives:', error);
                setLoading(false);
                return false;
            });
        } catch (err) {
            console.warn('Erreur lors du recalcul des prospectives:', err);
            setLoading(false);
            return false;
        }
    }

    async function saveIncidencesFinancieres()
    {
        try {
            // Parcourir le tableau des incidences financières et sauvegarder chaque année en BDD
            var i = 0;
            for (let year in incidences_financieres) {
                if (incidences_financieres.hasOwnProperty(year))
                {
                    const incidence = incidences_financieres[year];
                    // Sauvegarder chaque incidence en BDD
                    await axios.post('/api/incidences_financieres_operations.php', qs.stringify({
                        action: 'save',
                        id_operation: operation.id,
                        annee: year,
                        index: i,
                        ...incidence
                    }));
                }
                i++;
            }
            return await recalculateProspective();
        } catch (err) {
            setLoading(false);
            NotificationManager.error('Erreur lors de la sauvegarde des incidences financières', '', 3000);
            return false;
        }
    }

    const valider = async () => {
        if (!operation) return false;
        
        if (!operation.nom || !operation.nom.trim()) {
            NotificationManager.error('Le champ "Nom" est requis', '', 2500);
            return false;
        }

        setLoading(true);
        try {
            const params = {
                update: true,
                id: id,
                id_budget: operation.id_budget,
                numero_inventaire: operation.numero_inventaire,
                nom: operation.nom,
                enjeu: operation.enjeu,
                id_modalite_portage: operation.id_modalite_portage,
                date_premiere_acquisition: operation.date_premiere_acquisition,
                date_premiere_facturation: operation.date_premiere_facturation,
                duree_portage: operation.duree_portage,
                duree_differe: operation.duree_differe,
                id_axes_interventions: operation.id_axes_interventions,
                id_territoires: operation.id_territoires,
                gestionnaire_interne: operation.gestionnaire_interne,
                montant: operation.montant,
                description: operation.description,
                gestionnaire: operation.gestionnaire,
                prerequis_mise_en_oeuvre: operation.prerequis_mise_en_oeuvre,
                questions: operation.questions,
                id_clients_epfl: operation.id_clients_epfl,
                partenaires: operation.partenaires,
                service_referent: operation.service_referent,
                technicien_nom: operation.technicien_nom,
                technicien_mail: operation.technicien_mail,
                technicien_telephone: operation.technicien_telephone,
                technicien_fonction: operation.technicien_fonction,
                ressources_humaines: operation.ressources_humaines,
                etudes: operation.etudes,
                outils: operation.outils,
                investissements: operation.investissements,
                incidences_orga: operation.incidences_orga,
                etudes_programmatiques: operation.etudes_programmatiques,
                description_objectifs: operation.description_objectifs,
                niveau_atteinte_objectifs: operation.niveau_atteinte_objectifs,
                note: operation.note,
                ajustement_objectifs: operation.ajustement_objectifs,
                color: operation.color,
                h1: operation.h1 || 0,
                h2: operation.h2 || 0,
                h3: operation.h3 || 0
            };

            const res = await axios.post('/api/operations.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1)
            {
                // Sauvegarder le pilotage
                try {
                    await axios.post('/api/pilotage_projet.php', qs.stringify({
                        'update': true,
                        'id_operation': id,
                        'objet': pilotage_operation
                    }));
                } catch (e) {
                    console.error('Erreur sauvegarde pilotage:', e);
                }

                // Sauvegarder les incidences financières
                try {
                    return(saveIncidencesFinancieres());
                } catch (e) {
                    console.error('Erreur sauvegarde incidences financières:', e);
                }
            } else {
                NotificationManager.error((res && res.data && res.data.message) || 'Erreur mise à jour', '', 3000);
                setLoading(false);
                return false;
            }
        } catch (e) {
            NotificationManager.error('Erreur requête serveur', '', 3000);
            setLoading(false);
            return false;
        }
    };

    const updateOperationField = (field, value) => {
        // ✅ Créer une COPIE de l'objet au lieu d'une référence
        var tmp = { ...operation };
        tmp[field] = value;
        setOperation(tmp);
        setAff(!aff);
    };

    const updateIncidencesFinancieres = async (rowKey, value, year) => {
        // ✅ Créer une copie au lieu de muter directement
        var tmp = { ...incidences_financieres };
        if (tmp[year]) {
            tmp[year] = { ...tmp[year] };
            tmp[year][rowKey] = value;
        }
        setIncidences_financieres(tmp);
        recalculateAllTableFields(tmp);
        await setAff(!aff);
    };


    const recalculateAllTableFields = (incidencesUpdated = null) =>
    {
        if (!operation) return;
        if (!modalite_portage_selectionnee) return;
        
        // Créer une copie de incidences_financieres pour mettre à jour
        const tmp = { ...(incidencesUpdated || incidences_financieres) };
        
        // Extraire les variables nécessaires
        
        // Ici recupere moi le taux frais que l'on voit entre Durée differe et Solde d'opération
        const tauxFrais = parseFloat(modalite_portage_selectionnee.taux) || 0;
        const DP = parseInt(operation.duree_portage) || 0;
        const DD = parseInt(operation.duree_differe) || 0;
        const yearAcquisition = operation.date_premiere_acquisition ? new Date(operation.date_premiere_acquisition).getFullYear() : 0;
        let yearFirstFacturationIdx = 0;
        if (operation.date_premiere_acquisition && operation.date_premiere_facturation) {
            const yearFirstFacturation = new Date(operation.date_premiere_facturation).getFullYear();
            yearFirstFacturationIdx = yearFirstFacturation - yearAcquisition;
        }
        const akpStartIdx = yearFirstFacturationIdx + DD;
        
        // Ajouter le taux de la modalité de portage pour les calculs
        let tauxFraisModalite = 0;
        if (modalite_portage_selectionnee && modalite_portage_selectionnee.taux) {
            tauxFraisModalite = parseFloat(modalite_portage_selectionnee.taux);
        }
        
        // Initialisation des variables
        let cumulST1 = 0;
        let cumulST2 = 0;
        let cumulAT = 0;
        let akp = 0;
        let ahkp = 0;
        let cumulAKP = 0;
        let cumulAHKP = 0;
        let cumulSAFG = 0;
        const totalYears = yearFirstFacturationIdx + DP;

        // Créer array des années triées pour traiter dans l'ordre
        const years = Object.keys(tmp).map(k => parseInt(k)).filter(y => !isNaN(y)).sort((a, b) => a - b);
        
        // Parcourir les années dans l'ordre pour faire les calculs année pas année.
        for (let year of years)
        {
            const yearIdx = year - yearAcquisition;
            
            // Si on est pas dans la premiere année
            if (year > yearAcquisition)
            {
                // Vérifier si on est avant akpStartIdx - dans ce cas AKP et AHKP = 0
                if (yearIdx < akpStartIdx) {
                    // Avant le début du calcul (période de différé), AKP et AHKP = 0
                    tmp[year].annuite_capital_porte = 0;
                    tmp[year].annuite_hors_capital_porte = 0;
                } else {
                    // AKP = (cumul(ST1)n-1 - cumul(AKP)n-1) / années restantes
                    if (tmp[year].annuite_capital_porte_reel !== undefined && tmp[year].annuite_capital_porte_reel !== null && tmp[year].annuite_capital_porte_reel !== '' && tmp[year].annuite_capital_porte_reel !== 0) {
                        // si AKP-REEL existe, l'utiliser à la place de AKP calculé
                        akp = parseFloat(tmp[year].annuite_capital_porte_reel);
                    } else {
                        const anneesRestantes = totalYears - yearIdx;
                        akp = anneesRestantes > 0 ? (cumulST1 - cumulAKP) / anneesRestantes : 0;
                    }
                    tmp[year].annuite_capital_porte = akp;
                    cumulAKP += akp;

                    // AHKP = (cumul(ST2)n-1 - cumul(AHKP)n-1) / années restantes
                    if (tmp[year].annuite_hors_capital_porte_reel !== undefined && tmp[year].annuite_hors_capital_porte_reel !== null && tmp[year].annuite_hors_capital_porte_reel !== '' && tmp[year].annuite_hors_capital_porte_reel !== 0) {
                        // si AHKP-REEL existe, l'utiliser à la place de AHKP calculé
                        ahkp = parseFloat(tmp[year].annuite_hors_capital_porte_reel);
                    } else {
                        const anneesRestantes = totalYears - yearIdx;
                        ahkp = anneesRestantes > 0 ? (cumulST2 - cumulAHKP) / anneesRestantes : 0;
                    }
                    tmp[year].annuite_hors_capital_porte = ahkp;
                    cumulAHKP += ahkp;
                }

                // AT = AKP + AHKP
                const AT = tmp[year].annuite_capital_porte + tmp[year].annuite_hors_capital_porte;
                tmp[year].annuite_definitive = AT;
                cumulAT += AT;

                // Taux applicable capital = sa valeur si elle existe sinon taux frais de la modalité de portage
                if (tmp[year].taux_applicable_capital !== undefined && tmp[year].taux_applicable_capital !== null && tmp[year].taux_applicable_capital !== '') {
                    // si taux_applicable_capital existe, l'utiliser à la place de tauxFraisModalite
                    tmp[year].taux_applicable_capital = parseFloat(tmp[year].taux_applicable_capital);
                } else {
                    tmp[year].taux_applicable_capital = tauxFraisModalite;
                }

                // FPHT = (taux_frais / 100) * CFP(année précédente)
                const FPHT = (tmp[year].taux_applicable_capital / 100) * (tmp[year - 1] ? tmp[year - 1].total_capital_porte : 0);
                tmp[year].frais_portage_ht = FPHT;

                // TVAFP = FPHT * 0.2
                const TVAFP = FPHT * 0.2;
                tmp[year].tva_frais_portage = TVAFP;

                // FPTTC = FPHT + TVAFP
                const FPTTC = FPHT + TVAFP;
                tmp[year].frais_portage_ttc = FPTTC;

                // PTP = TIA n-1 * KS n-1
                const tauxInteret = tmp[year - 1] ? parseFloat(tmp[year - 1].taux_interet_moy_annuel || 0) : 0;
                const ks = tmp[year - 1] ? parseFloat(tmp[year - 1].total_capital_stocke || 0) : 0;
                const PTP = (tauxInteret / 100) * ks;
                tmp[year].taux_portage = PTP;
            }

            // ST1 = prix_acquisition + frais_actes - subventions - retrocessions
            const ST1 = (
                parseFloat(tmp[year].prix_acquisition || 0) +
                parseFloat(tmp[year].frais_actes || 0) -
                parseFloat(tmp[year].subventions || 0) -
                parseFloat(tmp[year].retrocessions || 0)
            );
            tmp[year].total_annuel_capital_porte = ST1;
            cumulST1 += ST1;

            // ST2 = frais_prealables + frais_annexes + frais_gegr + frais_proto_amenagement
            const ST2 = (
                parseFloat(tmp[year].frais_prealables || 0) +
                parseFloat(tmp[year].frais_annexes || 0) +
                parseFloat(tmp[year].frais_gegr || 0) +
                parseFloat(tmp[year].frais_proto_amenagement || 0)
            );
            tmp[year].total_annuel_hors_capital_porte = ST2;
            cumulST2 += ST2;

            // KS = cumul(ST1) + cumul(ST2) - cumul(AT)
            const KS = cumulST1 + cumulST2 - cumulAT;
            tmp[year].total_capital_stocke = KS;

            // CFP = cumul(ST1) - cumul(AKP)
            const CFP = cumulST1 - cumulAKP;
            tmp[year].total_capital_porte = CFP;

            // TOTDEP = ER + DEE + DCC + DTFB + DOM + DASS + DAU
            const TOTDEP = (
                parseFloat(tmp[year].entretien_reparations || 0)
                +
                parseFloat(tmp[year].eau_electricite || 0)
                +
                parseFloat(tmp[year].charges_copropriete || 0)
                +
                parseFloat(tmp[year].taxes_foncieres || 0)
                +
                parseFloat(tmp[year].taxe_redevance_om || 0)
                +
                parseFloat(tmp[year].assurances || 0)
                +
                parseFloat(tmp[year].autres_depenses || 0)
            );
            tmp[year].total_depenses = TOTDEP;

            // TOTREC = LOY + REE + RCC + RTFB + ROM + RASS + RAU
            const TOTREC = (
                parseFloat(tmp[year].loyers_percus || 0)
                +
                parseFloat(tmp[year].refacturation_eau_electricite || 0)
                +
                parseFloat(tmp[year].refacturation_charges_copropriete || 0)
                +
                parseFloat(tmp[year].refacturation_taxes_foncieres || 0)
                +
                parseFloat(tmp[year].refacturation_om || 0)
                +
                parseFloat(tmp[year].refacturation_assurances || 0)
                +
                parseFloat(tmp[year].autres_recettes || 0)
            );
            tmp[year].total_recettes = TOTREC;
            
            // SAFG = TOTDEP - TOTREC
            const SAFG = TOTDEP - TOTREC;
            tmp[year].solde_annuel_frais_gestion = SAFG;

            // SAFG cumulé
            cumulSAFG += SAFG;
            tmp[year].solde_cumule_frais_gestion = cumulSAFG;

            // SO = KS + cumulSAFG;
            const SO = KS + cumulSAFG;
            tmp[year].solde_operation = SO;

            // TIA = taux_annuel si cellule vide sinon valeur de la cellule
            tauxAnnuel.forEach(element => {
                if (parseInt(element[0]) === parseInt(year)) {
                    // Mettre à jour le taux annuel si la cellule est vide
                    if (!tmp[year].taux_interet_moy_annuel) {
                        tmp[year].taux_interet_moy_annuel = element[1];
                    }
                }
            });
        }
        
        // Persister et déclencher le rendu
        setIncidences_financieres(tmp);
        setAff(!aff);
    };


    return (
        <div>
            <Access needConnection={true} type_user={[0]}>
                <Navbar user={props.user} />

                <div style={{display: 'flex'}}>
                    <div style={{flex: 1, margin: 20, display: 'flex'}}>
                        <div style={{flex: 1, display: 'flex'}}>
                            <p>Opération {operation?.numero_inventaire || ''} :</p>
                            <p style={{marginLeft: 5, color: purple, fontWeight: 'bold'}}>{operation?.nom || ''}</p>
                        </div>
                        <div>
                            {props.user?
                            <p style={{flex: 1, textAlign: 'center'}}>{props.user.nom_budget}</p>
                            :null}
                        </div>
                        <div style={{flex: 1}}></div>
                    </div>
                </div>

                <div style={{flex: 1, textAlign: 'center'}}>
                    {operation?
                    <div style={{marginBottom: 100, marginRight: 50, marginLeft: 50}}>

                        <Dialog
                            setModalVisible={setDialogModalVisible}
                            modalVisible={dialogModalVisible}
                            callbackDialog={callbackDialog}
                            message={"Confirmez la suppression"}
                        />

                        <ModalPilotage
                            modalVisible={modalPilotage}
                            setModalVisible={setModalPilotage}
                            objet={objetPilotage}
                            user={props.user}
                        />

                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20, gap: 10, flexWrap: 'wrap', position: 'relative'}}>

                            <button
                            style={operation.color === green?{border: '2px solid '+green, borderRadius: '50%', width: 50, height: 50, backgroundColor: green, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box', padding: 0, flexShrink: 0}:{border: '2px solid '+green, borderRadius: '50%', width: 50, height: 50, backgroundColor: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box', padding: 0, flexShrink: 0}}
                            onClick={() => {
                                if (operation.color === green) {
                                    updateOperationField('color', null);
                                } else {
                                    updateOperationField('color', green);
                                }
                            }}
                            >
                            </button>

                            <button
                            style={operation.color === orange?{marginLeft: 0, border: '2px solid '+orange, borderRadius: '50%', width: 50, height: 50, backgroundColor: orange, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box', padding: 0, flexShrink: 0}:{marginLeft: 0, border: '2px solid '+orange, borderRadius: '50%', width: 50, height: 50, backgroundColor: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box', padding: 0, flexShrink: 0}}
                            onClick={() => {
                                if (operation.color === orange) {
                                    updateOperationField('color', null);
                                } else {
                                    updateOperationField('color', orange);
                                }
                            }}
                            >
                            </button>

                            <button
                            style={operation.color === red?{marginLeft: 0, border: '2px solid '+red, borderRadius: '50%', width: 50, height: 50, backgroundColor: red, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box', padding: 0, flexShrink: 0}:{marginLeft: 0, border: '2px solid '+red, borderRadius: '50%', width: 50, height: 50, backgroundColor: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box', padding: 0, flexShrink: 0}}
                            onClick={() => {
                                if (operation.color === red) {
                                    updateOperationField('color', null);
                                } else {
                                    updateOperationField('color', red);
                                }
                            }}
                            >
                            </button>
                            
                            <div style={{display: 'flex', gap: 5, flexWrap: 'wrap', justifyContent: 'center', flex: '1 1 100%', minWidth: '300px'}} className='button-tabs-container'>

                            <button
                                className='shadow-md p-2 rounded-md button-tab'
                                style={details?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 3, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 3, border: '1px solid '+purple, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}}
                                onClick={() => {
                                    setDetails(true);
                                    setMoyens(false);
                                    setEcheancier(false);
                                    setIncidences(false);
                                    setEvaluation(false);
                                    setDroits(false);
                                    setPilotage(false);
                                }}
                            >
                                Données générales
                            </button>

                            <button
                                className='shadow-md p-2 rounded-md button-tab'
                                style={moyens?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 3, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 3, border: '1px solid '+purple, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}}
                                onClick={() => {
                                    setDetails(false);
                                    setMoyens(true);
                                    setEcheancier(false);
                                    setIncidences(false);
                                    setEvaluation(false);
                                    setDroits(false);
                                    setPilotage(false);
                                }}
                            >
                                Moyens mis en œuvre
                            </button>

                            <button
                                className='shadow-md p-2 rounded-md button-tab'
                                style={echeancier?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 3, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 3, border: '1px solid '+purple, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}}
                                onClick={() => {
                                    setDetails(false);
                                    setMoyens(false);
                                    setEcheancier(true);
                                    setIncidences(false);
                                    setEvaluation(false);
                                    setDroits(false);
                                    setPilotage(false);
                                }}
                            >
                                Échéancier
                            </button>

                            <button
                                className='shadow-md p-2 rounded-md button-tab'
                                style={incidences?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 3, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 3, border: '1px solid '+purple, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}}
                                onClick={() => {
                                    setDetails(false);
                                    setMoyens(false);
                                    setEcheancier(false);
                                    setIncidences(true);
                                    setDroits(false);
                                    setEvaluation(false);
                                    setPilotage(false);
                                    loadIncidencesFinancieres(operation.id, operation, modalite_portage_selectionnee)
                                }}
                            >
                                Incidences Financières
                            </button>

                            <button
                                className='shadow-md p-2 rounded-md button-tab'
                                style={evaluation?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 3, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 3, border: '1px solid '+purple, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}}
                                onClick={() => {
                                    setDetails(false);
                                    setMoyens(false);
                                    setEcheancier(false);
                                    setIncidences(false);
                                    setEvaluation(true);
                                    setDroits(false);
                                    setPilotage(false);
                                }}
                            >
                                Évaluation
                            </button>

                            <button
                                className='shadow-md p-2 rounded-md button-tab'
                                style={pilotage?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 3, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 3, border: '1px solid '+purple, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}}
                                onClick={() => {
                                    setDetails(false);
                                    setMoyens(false);
                                    setEcheancier(false);
                                    setEvaluation(false);
                                    setIncidences(false);
                                    setDroits(false);
                                    setPilotage(true);
                                }}
                            >
                                Pilotage
                            </button>

                            <button
                                className='shadow-md p-2 rounded-md button-tab'
                                style={droits?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 3, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 3, border: '1px solid '+purple, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flex: '1 1 calc(33.333% - 10px)', minWidth: '120px'}}
                                onClick={() => {
                                    setDetails(false);
                                    setMoyens(false);
                                    setEcheancier(false);
                                    setIncidences(false);
                                    setEvaluation(false);
                                    setPilotage(false);
                                    setDroits(true);
                                }}
                            >
                                Droits
                            </button>

                            </div>

                            {!canModify ? (
                                <div
                                    className='shadow-md rounded-md'
                                    style={{position: 'absolute', top: 0, right: 0, backgroundColor: '#cccccc', color: 'white', fontSize: 13, alignItems: 'center', justifyContent: 'center', display: 'flex', paddingLeft: 15, paddingRight: 15, flexShrink: 0, height: 40, borderRadius: 6}}
                                    title="Vous n'avez pas les droits de modification sur cette opération"
                                >
                                    <p style={{margin: 0}}>Droits insuffisants</p>
                                </div>
                            ) : (
                                <button
                                    disabled={loading}
                                    className='shadow-md rounded-md'
                                    style={{position: 'absolute', top: 0, right: 0, backgroundColor: loading ? '#cccccc' : green, color: 'white', fontSize: 14, alignItems: 'center', justifyContent: 'center', display: 'flex', paddingLeft: 10, paddingRight: 10, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, flexShrink: 0, height: 40}}
                                    onClick={async () => {
                                        setDetails(false);
                                        setMoyens(false);
                                        setEcheancier(false);
                                        setEvaluation(false);
                                        setIncidences(false);
                                        setPilotage(false);
                                        setDroits(false);
                                        const success = await valider();
                                        if (success) {
                                            setLoading(false);
                                            setDetails(true);
                                            // setTimeout(() => {history.push('/operations?timestamp=' + new Date().getTime())}, 2000);
                                        }
                                    }}
                                >
                                    {loading ? (
                                        <>
                                            <BounceLoader color="white" size={12} />
                                            <p style={{marginLeft: 10}}>Recalcul</p>
                                        </>
                                    ) : (
                                        <>
                                            <Check width="12" />
                                            <p style={{marginLeft: 10}}>Valider</p>
                                        </>
                                    )}
                                    <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
                                    
                                    @media (max-width: 1024px) {
                                      .button-tabs-container {
                                        order: 3 !important;
                                        width: 100% !important;
                                      }
                                    }`}</style>
                                </button>
                            )}

                        </div>


                        {loading &&
                        <div style={{justifyContent: 'center', alignItems: 'center', display: 'flex', marginTop: 50}}>
                            <BounceLoader color={purple} size={60} />
                        </div>
                        }
                        {/****************************** Données générales ********************************/}
                        {details?
                        <div>

                            {/* Ligne 1: Intitulé + Numéro d'inventaire */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{display: 'flex', flex: 4}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                        <p style={{margin: 0}}>Intitulé</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                    <input
                                        style={{ flex: 1, padding: 8, fontSize: 15, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateOperationField('nom', e.target.value)}
                                        value={operation.nom || ''}
                                    />
                                    </div>
                                </div>

                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{}}>N° inventaire</p>
                                    </div>
                                    <input
                                        style={{ width: '100%', padding: 8, fontSize: 15, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateOperationField('numero_inventaire', e.target.value)}
                                        value={operation.numero_inventaire || ''}
                                    />
                                </div>
                            </div>

                            {/* Ligne 3: Montant */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{display: 'flex', flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                        <p style={{margin: 0}}>Montant (€ TTC)</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1, alignItems: 'center'}}>
                                    <input
                                        type="text"
                                        style={{ flex: 1, padding: 8, fontSize: 15, border: 'none', outline: 'none' }}
                                        onBlur={async (e) => {
                                            if (e.target.value !== '' && (parseFloat(e.target.value) || e.target.value === '0')) {
                                                const cleanValue = (Math.round(parseFloat(e.target.value) * 100) / 100).toString().replace(',', '.').replace('€', '').replace(' ', '').replace("'", '').replace('"', '');
                                                updateOperationField('montant', cleanValue);
                                                if (!e.target.value.includes('€')) {
                                                    e.target.value = addSpace((Math.round(parseFloat(e.target.value) * 100) / 100).toString().replace("'", '').replace('"', ''))+'€';
                                                }
                                                await setAff(!aff);
                                            }
                                            e.target.value = '';
                                        }}
                                        placeholder={operation.montant !== null && operation.montant !== '' ? addSpace(parseFloat(operation.montant))+'€' : '0€'}
                                    />
                                    </div>
                                </div>
                            </div>

                            {/* Ligne 2: Client + Axe + Territoire + Modalité */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 50}}>
                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Collectivités</p>
                                    </div>
                                    <select
                                        style={{ width: '100%', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateOperationField('id_clients_epfl', e.target.value ? parseInt(e.target.value) : '')}
                                        value={operation.id_clients_epfl || ''}
                                    >
                                        <option value=''>-- Aucun --</option>
                                        {clients.map(c => (
                                            <option key={c.id} value={c.id}>{c.nom}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Axe d'intervention</p>
                                    </div>
                                    <select
                                        style={{ width: '100%', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateOperationField('id_axes_interventions', e.target.value ? parseInt(e.target.value) : '')}
                                        value={operation.id_axes_interventions || ''}
                                    >
                                        <option value=''>-- Aucun --</option>
                                        {axes.map(a => (
                                            <option key={a.id} value={a.id}>{a.intitule}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Territoires</p>
                                    </div>
                                    <select
                                        style={{ width: '100%', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateOperationField('id_territoires', e.target.value ? parseInt(e.target.value) : '')}
                                        value={operation.id_territoires || ''}
                                    >
                                        <option value=''>-- Aucun --</option>
                                        {territoires.map(t => (
                                            <option key={t.id} value={t.id}>{t.intitule}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Modalités de portage</p>
                                    </div>
                                    <select
                                        style={{ width: '100%', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => {
                                            updateOperationField('id_modalite_portage', e.target.value ? parseInt(e.target.value) : '');
                                            modalites.forEach(element => {
                                                if (parseInt(element.id) === parseInt(e.target.value)) {
                                                    setModalite_portage_selectionnee(element);
                                                }
                                            });
                                        }}
                                        value={operation.id_modalite_portage || ''}
                                    >
                                        <option value=''>-- Aucune --</option>
                                        {modalites.map(m => (
                                            <option key={m.id} value={m.id}>{m.intitule}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Ligne 9: Dates */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Date de 1ère acquisition</p>
                                    </div>
                                    <input
                                        type="date"
                                        style={{ width: '100%', textAlign: 'center', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateOperationField('date_premiere_acquisition', e.target.value)}
                                        value={operation.date_premiere_acquisition || ''}
                                    />
                                </div>

                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Date de 1ère facturation</p>
                                    </div>
                                    <input
                                        type="date"
                                        style={{ width: '100%', textAlign: 'center', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateOperationField('date_premiere_facturation', e.target.value)}
                                        value={operation.date_premiere_facturation || ''}
                                    />
                                </div>
                            </div>

                            {/* Ligne 10: Durées */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 50}}>
                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Durée de portage (en années)</p>
                                    </div>
                                    <input
                                        type="number"
                                        style={{ width: '100%', textAlign: 'center', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => {
                                            if (e.target.value >= 0) {
                                                updateOperationField('duree_portage', e.target.value);
                                            }
                                            else {
                                                updateOperationField('duree_portage', 0);
                                            }
                                        }}
                                        value={operation.duree_portage || ''}
                                    />
                                </div>

                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Durée de différé (en années)</p>
                                    </div>
                                    <input
                                        type="number"
                                        style={{ width: '100%', textAlign: 'center', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => {
                                            if (e.target.value >= 0) {
                                                updateOperationField('duree_differe', e.target.value);
                                            }
                                            else {
                                                updateOperationField('duree_differe', 0);
                                            }
                                        }}
                                        value={operation.duree_differe !== undefined && operation.duree_differe !== null ? operation.duree_differe : 0}
                                    />
                                </div>
                            </div>

                            {/* Ligne 4: Description */}
                            <div style={{display: 'flex', marginBottom: 10}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Description</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                <textarea
                                    rows={4}
                                    style={{ flex: 1, padding: 8, fontSize: 14, resize: 'vertical', border: 'none', outline: 'none' }}
                                    onChange={(e) => updateOperationField('description', e.target.value)}
                                    value={operation.description || ''}
                                />
                                </div>
                            </div>

                            <div style={{display: 'flex', marginBottom: 10}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Enjeu</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                <textarea
                                    rows={4}
                                    style={{ flex: 1, padding: 8, fontSize: 14, resize: 'vertical', border: 'none', outline: 'none' }}
                                    onChange={(e) => updateOperationField('enjeu', e.target.value)}
                                    value={operation.enjeu || ''}
                                />
                                </div>
                            </div>

                            {/* Ligne 11: Prérequis */}
                            <div style={{display: 'flex', marginBottom: 10}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Prérequis de mise en œuvre</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                <textarea
                                    rows={3}
                                    style={{ flex: 1, padding: 8, fontSize: 14, resize: 'vertical', border: 'none', outline: 'none' }}
                                    onChange={(e) => updateOperationField('prerequis_mise_en_oeuvre', e.target.value)}
                                    value={operation.prerequis_mise_en_oeuvre || ''}
                                />
                                </div>
                            </div>

                            {/* Ligne 12: Questions */}
                            <div style={{display: 'flex', marginBottom: 10}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Questions / Remarques</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                <textarea
                                    rows={3}
                                    style={{ flex: 1, padding: 8, fontSize: 14, resize: 'vertical', border: 'none', outline: 'none' }}
                                    onChange={(e) => updateOperationField('questions', e.target.value)}
                                    value={operation.questions || ''}
                                />
                                </div>
                            </div>

                            {/* Ligne 13: Partenaires à mobiliser */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 50}}>
                                <div style={{display: 'flex', flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300, flexDirection: 'column'}}>
                                        <p style={{margin: 0}}>Partenaires à mobiliser</p>
                                        <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.partenaires || '').length}/255</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                    <textarea
                                        rows={2}
                                        maxLength={255}
                                        style={{ flex: 1, padding: 8, fontSize: 14, resize: 'vertical', border: 'none', outline: 'none' }}
                                        onChange={(e) => updateOperationField('partenaires', e.target.value)}
                                        value={operation.partenaires || ''}
                                    />
                                    </div>
                                </div>
                            </div>

                            {/* Ligne 5: Gestionnaires */}
                            {/* <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{display: 'flex', flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                        <p style={{margin: 0}}>Gestionnaire</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                    <input
                                        style={{ flex: 1, padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateOperationField('gestionnaire', e.target.value)}
                                        value={operation.gestionnaire || ''}
                                    />
                                    </div>
                                </div>
                            </div> */}

                            <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{display: 'flex', flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                        <p style={{margin: 0}}>Gestionnaire interne</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                    <input
                                        style={{ flex: 1, padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateOperationField('gestionnaire_interne', e.target.value)}
                                        value={operation.gestionnaire_interne || ''}
                                    />
                                    </div>
                                </div>
                            </div>

                            {/* Ligne 6: Service référent + Partenaires */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{display: 'flex', flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                        <p style={{margin: 0}}>Service référent</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                    <input
                                        style={{ flex: 1, padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateOperationField('service_referent', e.target.value)}
                                        value={operation.service_referent || ''}
                                    />
                                    </div>
                                </div>

                            </div>

                            {/* Ligne 7: Technicien référent */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 10}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Technicien référent</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>

                                    <div style={{flex: 1, padding: 5}}>
                                        <div style={{display: 'flex'}}>
                                            <input
                                            className='shadow-md rounded-md'
                                            style={{flex: 1, padding: 5, textAlign: 'center'}}
                                            onChange={(e) => {
                                                updateOperationField('technicien_nom', e.target.value);
                                            }}
                                            onBlur={() => {
                                                const trimmed = operation.technicien_nom ? operation.technicien_nom.trim().replace(/\s+/g, ' ') : '';
                                                updateOperationField('technicien_nom', trimmed);
                                            }}
                                            value={operation.technicien_nom === null ? "" : rescueHtml(operation.technicien_nom)}
                                            placeholder='Nom'
                                            />
                                        </div>
                                    </div>

                                    <div style={{flex: 1, padding: 5}}>
                                        <div style={{display: 'flex'}}>
                                            <input
                                            className='shadow-md rounded-md'
                                            style={{flex: 1, padding: 5, textAlign: 'center'}}
                                            type="email"
                                            onChange={(e) => {
                                                updateOperationField('technicien_mail', e.target.value);
                                            }}
                                            onBlur={() => {
                                                const trimmed = operation.technicien_mail ? operation.technicien_mail.trim().replace(/\s+/g, '') : '';
                                                updateOperationField('technicien_mail', trimmed);
                                            }}
                                            value={operation.technicien_mail === null ? "" : rescueHtml(operation.technicien_mail)}
                                            placeholder='Email'
                                            />
                                        </div>
                                    </div>
                                    <div style={{padding: 5}}>
                                        <input
                                        className='shadow-md rounded-md'
                                        type="tel"
                                        style={{padding: 5, textAlign: 'center'}}
                                        onChange={(e) => {
                                            // Format: ajouter un espace tous les 2 chiffres
                                            let value = e.target.value.replace(/\s/g, '');
                                            let formatted = value.match(/.{1,2}/g)?.join('') || value;
                                            updateOperationField('technicien_telephone', formatted);
                                        }}
                                        onBlur={() => {
                                            const trimmed = operation.technicien_telephone ? operation.technicien_telephone.trim() : '';
                                            updateOperationField('technicien_telephone', trimmed);
                                        }}
                                        value={operation.technicien_telephone === null ? "" : rescueHtml(operation.technicien_telephone).replace(/\s/g, '').match(/.{1,2}/g)?.join(' ') || rescueHtml(operation.technicien_telephone)}
                                        placeholder='Téléphone'
                                        />
                                    </div>
                                </div>
                            </div>
                            {/****/}

                            {/* Ligne 8: Fonction technicien référent */}
                            <div style={{display: 'flex', marginBottom: 50}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Fonction technicien référent</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                    <input
                                    style={{flex: 1, padding: 5}}
                                    onChange={(e) => {
                                        updateOperationField('technicien_fonction', e.target.value);
                                    }}
                                    onBlur={() => {
                                        const trimmed = operation.technicien_fonction ? operation.technicien_fonction.trim().replace(/\s+/g, ' ') : '';
                                        updateOperationField('technicien_fonction', trimmed);
                                    }}
                                    value={operation.technicien_fonction === null ? "" : rescueHtml(operation.technicien_fonction)}
                                    />
                                </div>
                            </div>
                            {/****/}

                        </div>
                        :null}

                        {/****************************** Moyens mis en œuvre ********************************/}
                        {moyens?
                        <div>

                            {/* Ressources humaines */}
                            <div style={{display: 'flex', margin: 10}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175, display: 'flex', flexDirection: 'column'}}>
                                    <p>Ressources humaines</p>
                                    <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.ressources_humaines || '').length}/255</p>
                                </div>
                                <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                                <textarea
                                    rows={5}
                                    maxLength={255}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateOperationField('ressources_humaines', e.target.value)}
                                    value={operation.ressources_humaines || ''}
                                />
                                </div>
                            </div>

                            {/* Études */}
                            <div style={{display: 'flex', margin: 10}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175, display: 'flex', flexDirection: 'column'}}>
                                    <p>Études</p>
                                    <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.etudes || '').length}/255</p>
                                </div>
                                <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                                <textarea
                                    rows={5}
                                    maxLength={255}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateOperationField('etudes', e.target.value)}
                                    value={operation.etudes || ''}
                                />
                                </div>
                            </div>

                            {/* Outils */}
                            <div style={{display: 'flex', margin: 10}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175, display: 'flex', flexDirection: 'column'}}>
                                    <p>Outils</p>
                                    <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.outils || '').length}/255</p>
                                </div>
                                <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                                <textarea
                                    rows={5}
                                    maxLength={255}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateOperationField('outils', e.target.value)}
                                    value={operation.outils || ''}
                                />
                                </div>
                            </div>

                            {/* Investissements */}
                            <div style={{display: 'flex', margin: 10}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175, display: 'flex', flexDirection: 'column'}}>
                                    <p>Investissements</p>
                                    <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.investissements || '').length}/255</p>
                                </div>
                                <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                                <textarea
                                    rows={5}
                                    maxLength={255}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateOperationField('investissements', e.target.value)}
                                    value={operation.investissements || ''}
                                />
                                </div>
                            </div>

                            {/* Incidences organisationnelles */}
                            <div style={{display: 'flex', margin: 10}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175, display: 'flex', flexDirection: 'column'}}>
                                    <p>Incidences organisationnelles</p>
                                    <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.incidences_orga || '').length}/255</p>
                                </div>
                                <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                                <textarea
                                    rows={5}
                                    maxLength={255}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateOperationField('incidences_orga', e.target.value)}
                                    value={operation.incidences_orga || ''}
                                />
                                </div>
                            </div>

                        </div>
                        :null}

                        {/****************************** Échéancier ********************************/}
                        {echeancier?
                        <div>

                            {/* Études programmatiques */}
                            <div style={{display: 'flex', margin: 10, minHeight: 100}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175}}>
                                    <p>Études programmatiques</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                <textarea
                                    rows={5}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateOperationField('etudes_programmatiques', e.target.value)}
                                    value={operation.etudes_programmatiques || ''}
                                />
                                </div>
                            </div>

                            <div style={{marginTop: 20}}>
                                <Gantt user={props.user} id_operation={id} operation={operation}/>
                            </div>

                        </div>
                        :null}

                        {/****************************** Incidences Financières ********************************/}
                        {incidences?
                        (operation && operation.date_premiere_acquisition && operation.date_premiere_facturation && operation.duree_portage && operation.duree_portage > 0 && operation.id_modalite_portage?
                        (new Date(operation.date_premiere_facturation) >= new Date(operation.date_premiere_acquisition)?
                        <IncidencesFinancieresOperations
                            incidences={incidences}
                            operation={operation}
                            incidences_financieres={incidences_financieres}
                            updateIncidencesFinancieres={updateIncidencesFinancieres}
                            modalite_portage={modalite_portage_selectionnee}
                        />
                        :
                        <div style={{textAlign: 'center', marginTop: 50, padding: 20}} className='shadow-md rounded-md'>
                            <p style={{color: 'red', fontSize: 16}}>Erreur : La date de 1ère facturation doit être supérieure ou égale à la date d'acquisition</p>
                        </div>
                        )
                        :
                        <div style={{textAlign: 'center', marginTop: 50, padding: 20}} className='shadow-md rounded-md'>
                            <p style={{color: 'red', fontSize: 16}}>Veuillez renseigner tous les champs obligatoires dans l'onglet 'Données générales' :</p>
                            <ul style={{color: '#666', textAlign: 'left', display: 'inline-block'}}>
                                {!operation.date_premiere_acquisition && <li>Date de 1ère acquisition</li>}
                                {!operation.date_premiere_facturation && <li>Date de 1ère facturation</li>}
                                {!operation.duree_portage || operation.duree_portage <= 0 && <li>Durée de portage (doit être supérieure à 0)</li>}
                                {!operation.id_modalite_portage && <li>Modalité de portage</li>}
                            </ul>
                        </div>
                        )
                        :null}

                        {/****************************** Évaluation ********************************/}
                        {evaluation?
                        <div>

                            {/* Description des objectifs */}
                            <div style={{display: 'flex', margin: 10, minHeight: 150}} className='shadow-md rounded-md'>
                                <div style={{padding: 10, backgroundColor: greyChapter, alignItems: 'center', width: 350}}>
                                    <p>Description des objectifs</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                    <textarea
                                    rows={5}
                                    style={{flex: 1, padding: 5}}
                                    onChange={(e) => updateOperationField('description_objectifs', e.target.value)}
                                    onBlur={() => {
                                        const trimmed = operation.description_objectifs ? operation.description_objectifs.trim() : '';
                                        updateOperationField('description_objectifs', trimmed);
                                    }}
                                    value={operation.description_objectifs === null ? "" : rescueHtml(operation.description_objectifs)}
                                    />
                                </div>
                            </div>

                            <div style={{display: 'flex'}}>
                                {/* Niveau atteinte des objectifs */}
                                <div style={{flex: 1, display: 'flex', margin: 10, minHeight: 150}} className='shadow-md rounded-md'>
                                    <div style={{padding: 10, backgroundColor: greyChapter, alignItems: 'center', width: 350}}>
                                        <p>Niveau atteinte des objectifs</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                        <textarea
                                        rows={5}
                                        style={{flex: 1, padding: 5}}
                                        onChange={(e) => updateOperationField('niveau_atteinte_objectifs', e.target.value)}
                                        onBlur={() => {
                                            const trimmed = operation.niveau_atteinte_objectifs ? operation.niveau_atteinte_objectifs.trim() : '';
                                            updateOperationField('niveau_atteinte_objectifs', trimmed);
                                        }}
                                        value={operation.niveau_atteinte_objectifs === null ? "" : rescueHtml(operation.niveau_atteinte_objectifs)}
                                        />
                                    </div>
                                </div>

                                {/* Jauge - note */}
                                <div style={{display: 'flex'}}>
                                    <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 150}}>
                                        <div>
                                            <GaugeComponent
                                                type="radial"
                                                arc={{
                                                    width: 0.3,
                                                    padding: 0.02,
                                                    cornerRadius: 3,
                                                    subArcs: [
                                                        { limit: 1, color: '#FF0000' },
                                                        { limit: 2, color: '#FF4D4D' },
                                                        { limit: 3, color: '#FF6666' },
                                                        { limit: 4, color: '#FFDB99' },
                                                        { limit: 5, color: '#FFBF40' },
                                                        { limit: 6, color: '#FFA500' },
                                                        { limit: 7, color: '#CCBF33' },
                                                        { limit: 8, color: '#99CC66' },
                                                        { limit: 9, color: '#85C97A' },
                                                        { limit: 10, color: '#59B44A' }
                                                    ]
                                                }}
                                                pointer={{
                                                    color: purple,
                                                    length: 0.7,
                                                    width: 20
                                                }}
                                                value={operation.note !== null && operation.note !== undefined ? operation.note : 0}
                                                labels={{
                                                    valueLabel: { style: { display: 'none' } }
                                                }}
                                                minValue={0}
                                                maxValue={10}
                                                style={{flex: 1}}
                                            />
                                        
                                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 25}}>
                                                <input
                                                    className='shadow-md rounded-md'
                                                    style={{width: 40, textAlign: 'center'}}
                                                    min={0}
                                                    max={10}
                                                    step={1}
                                                    onBlur={(e) => {
                                                        let val = parseInt(e.target.value, 10);
                                                        if (isNaN(val)) val = 0;
                                                        if (val < 0) val = 0;
                                                        if (val > 10) val = 10;
                                                        updateOperationField('note', val);
                                                    }}
                                                    value={operation.note !== null && operation.note !== undefined ? operation.note : 0}
                                                    onChange={e => {
                                                        let val = e.target.value;
                                                        if (val === "") {
                                                            updateOperationField('note', "");
                                                        } else {
                                                            let num = parseInt(val, 10);
                                                            if (!isNaN(num) && num >= 0 && num <= 10) {
                                                                updateOperationField('note', num);
                                                            }
                                                        }
                                                    }}
                                                />
                                                <p>/ 10</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Ajustement des objectifs */}
                            <div style={{display: 'flex', margin: 10, minHeight: 150}} className='shadow-md rounded-md'>
                                <div style={{padding: 10, backgroundColor: greyChapter, alignItems: 'center', width: 350}}>
                                    <p>Ajustement des objectifs</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                    <textarea
                                    rows={5}
                                    style={{flex: 1, padding: 5}}
                                    onChange={(e) => updateOperationField('ajustement_objectifs', e.target.value)}
                                    onBlur={() => {
                                        const trimmed = operation.ajustement_objectifs ? operation.ajustement_objectifs.trim() : '';
                                        updateOperationField('ajustement_objectifs', trimmed);
                                    }}
                                    value={operation.ajustement_objectifs === null ? "" : rescueHtml(operation.ajustement_objectifs)}
                                    />
                                </div>
                            </div>

                        </div>
                        :null}

                        {/****************************** Pilotage ********************************/}
                        {pilotage?
                        <div>
                            <div style={{flex: 1, display: 'flex', borderTopLeftRadius: 2}}>
                                <div style={{flex: 0.15, minWidth: 20, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <Trash width="15" />
                                </div>
                                <div style={{flex: 0.6, minWidth: 90, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Date</p>
                                </div>
                                <div style={{flex: 1, minWidth: 180, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Instance réunie</p>
                                </div>
                                <div style={{flex: 1.5, minWidth: 300, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Relevé de décisions</p>
                                </div>
                                <div style={{flex: 1.5, minWidth: 300, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Action suivante</p>
                                </div>
                                <div style={{flex: 0.6, minWidth: 90, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Date limite de l'action</p>
                                </div>
                                <div style={{flex: 1, minWidth: 130, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Responsable de l'action</p>
                                </div>
                            </div>

                            <div style={{flex: 1, height: heightObject, borderBottomRightRadius: 3, borderBottomLeftRadius: 3}}>
                                {pilotage_operation.map((line, i) =>
                                
                                <div key={i} style={{flex: 1, padding: 5, borderRadius: 5, display: 'flex', marginTop: 10, color: line[10] == 0 && (new Date(line[7])) <= (new Date()) ? 'white':'black', backgroundColor: line[10] == 1? green:line[10] == 0 && (new Date(line[7])) <= (new Date()) ? red : '#ffffff'}} className='shadow-md'>
                                    
                                    <button
                                    style={{flex: 0.15, minWidth: 20, justifyContent: 'center', alignItems: 'center', display: 'flex'}}
                                    onClick={async () => {
                                        await setDialogModalVisible(true);
                                        await setPilotageLineSelected(line[0]);
                                    }}
                                    >
                                        <Trash width="16" />
                                    </button>

                                    {/* Date */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 0.6, minWidth: 90, alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}
                                    >
                                        <p>{line[3]?line[3].split('-')[2]+'/'+line[3].split('-')[1]+'/'+line[3].split('-')[0]:null}</p>
                                    </button>

                                    {/* Instance reunie */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 1, minWidth: 180, alignItems: 'center', justifyContent: 'center'}}
                                    >
                                        <p>{rescueHtml(line[4])}</p>
                                    </button>

                                    {/* Releve de decision */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 1.5, minWidth: 300, alignItems: 'center', justifyContent: 'center'}}
                                    >
                                        <p>
                                            {
                                            rescueHtml(line[5])
                                            .split('\\n')[0]
                                            .slice(0, 35) + (rescueHtml(line[5]).split('\\n')[0].length > 35 ? '...' : '')
                                            }
                                        </p>
                                    </button>

                                    {/* Action suivante */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 1.5, minWidth: 300, alignItems: 'center', justifyContent: 'center'}}
                                    >
                                        <p>
                                            {
                                            rescueHtml(line[6])
                                            .split('\\n')[0]
                                            .slice(0, 35) + (rescueHtml(line[6]).split('\\n')[0].length > 35 ? '...' : '')
                                            }
                                        </p>
                                    </button>

                                    {/* Date limite */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 0.6, minWidth: 90, alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}
                                    >
                                        <p>{line[7]?line[7].split('-')[2]+'/'+line[7].split('-')[1]+'/'+line[7].split('-')[0]:null}</p>
                                    </button>

                                    {/* Responsable de saisie */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 1, minWidth: 130, alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}
                                    >
                                        <p>{line[8]}</p>
                                    </button>

                                </div>
                                )}
                                <div style={{display: 'flex'}}>
                                    <div style={{flex: 1}}></div>
                                    <div style={{marginTop: 10, marginBottom: 10}}>
                                    <button
                                        className='shadow-md rounded-md'
                                        style={{backgroundColor: purple, color: 'white', fontSize: 17, alignItems: 'center', justifyContent: 'center', display: 'flex', paddingLeft: 10, paddingRight: 10}}
                                        onClick={async () => {
                                            addLinePilotage();
                                        }}
                                    >
                                        <Add width="12" />
                                        <p style={{marginLeft: 10}}>Ajouter une ligne</p>
                                    </button>
                                    </div>
                                    <div style={{flex: 1}}></div>
                                </div>
                            </div>
                            
                        </div>
                        :null}

                        {/****************************** Droits ********************************/}
                        {droits?
                        <div style={{backgroundColor: '#f8f9fa', borderRadius: 5}}>
                            <div style={{marginBottom: 25}}>
                                <h2 style={{margin: '0 0 10px 0', color: purple, fontSize: 22}}>Permissions d'accès pour cette opération</h2>
                                <p style={{margin: 0, color: '#666', fontSize: 14}}>Gérez les droits de consultation et modification des utilisateurs</p>
                            </div>



                            {/* Liste des utilisateurs */}
                            <div style={{backgroundColor: 'white', borderRadius: 8, border: '1px solid #ddd', overflow: 'hidden'}}>
                                {/* En-tête */}
                                <div style={{display: 'flex', backgroundColor: blue, color: 'white', padding: '12px 15px', gap: 15, fontWeight: 'bold', fontSize: 13, borderBottom: '2px solid #ddd'}}>
                                    <div style={{flex: 0.1, textAlign: 'center'}}>Connecté</div>
                                    <div style={{flex: 1}}>Utilisateur</div>
                                    <div style={{flex: 1.2}}>Email</div>
                                    <div style={{flex: 0.15, textAlign: 'center'}}>Rang</div>
                                    <button
                                        onClick={async () => {
                                            let allUserIds = users.map(u => u.id);
                                            // Vérifier si tous les utilisateurs ont déjà la visu
                                            let allHaveVisu = users.every(u => operation && operation.id_users_droits_visu && operation.id_users_droits_visu.split(';').includes(u.id));
                                            
                                            if (allHaveVisu) {
                                                // Enlever la visu à tous ET la modif à tous
                                                operation.id_users_droits_visu = '';
                                                operation.id_users_droits_modif = '';
                                            } else {
                                                // Ajouter la visu à tous
                                                operation.id_users_droits_visu = allUserIds.join(';');
                                            }
                                            var tmp = operation;
                                            await setOperation(tmp);
                                            var params = {
                                                'update': true,
                                                'id_users_droits_visu': tmp.id_users_droits_visu,
                                                'id_users_droits_modif': tmp.id_users_droits_modif,
                                                'id': tmp.id
                                            };
                                            await axios.post("https://app-slfinance.fr/api/operations.php", qs.stringify(params))
                                            await setAff(!aff);
                                        }}
                                        style={{
                                            flex: 0.3,
                                            textAlign: 'center',
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                            color: 'white',
                                            cursor: 'pointer',
                                            fontSize: 13,
                                            fontWeight: 'bold',
                                            padding: 0,
                                            transition: 'opacity 0.2s'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
                                        onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                                    >
                                        Consulter
                                        <p style={{fontSize: 9}}>(tout cocher)</p>
                                    </button>
                                    <button
                                        onClick={async () => {
                                            let allUserIds = users.map(u => u.id);
                                            // Vérifier si tous les utilisateurs ont déjà la modif
                                            let allHaveModif = users.every(u => operation && operation.id_users_droits_modif && operation.id_users_droits_modif.split(';').includes(u.id));
                                            
                                            if (allHaveModif) {
                                                // Enlever la modif à tous
                                                operation.id_users_droits_modif = '';
                                            } else {
                                                // Ajouter la modif à tous + visu
                                                operation.id_users_droits_modif = allUserIds.join(';');
                                                operation.id_users_droits_visu = allUserIds.join(';');
                                            }
                                            var tmp = operation;
                                            await setOperation(tmp);
                                            var params = {
                                                'update': true,
                                                'id_users_droits_visu': tmp.id_users_droits_visu,
                                                'id_users_droits_modif': tmp.id_users_droits_modif,
                                                'id': tmp.id
                                            };
                                            await axios.post("https://app-slfinance.fr/api/operations.php", qs.stringify(params))
                                            await setAff(!aff);
                                        }}
                                        style={{
                                            flex: 0.3,
                                            textAlign: 'center',
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                            color: 'white',
                                            cursor: 'pointer',
                                            fontSize: 13,
                                            fontWeight: 'bold',
                                            padding: 0,
                                            transition: 'opacity 0.2s'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
                                        onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                                    >
                                        Modifier
                                        <p style={{fontSize: 9}}>(tout cocher)</p>
                                    </button>
                                </div>

                                {/* Liste */}
                                <div style={{maxHeight: heightObject, overflowY: 'auto'}}>
                                    {users && users.length > 0 ? users.map((user, i) => (
                                        <div
                                            key={i}
                                            style={{
                                                display: 'flex',
                                                padding: '12px 15px',
                                                gap: 15,
                                                borderBottom: i < users.length - 1 ? '1px solid #eee' : 'none',
                                                alignItems: 'center',
                                                backgroundColor: i % 2 === 0 ? '#ffffff' : '#fafafa',
                                                transition: 'background-color 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#ffffff' : '#fafafa'}
                                        >
                                            {/* Indicateur de session */}
                                            <div style={{flex: 0.1, display: 'flex', justifyContent: 'center'}}>
                                                <div style={{
                                                    width: 10,
                                                    height: 10,
                                                    backgroundColor: user.session_token ? green : '#ccc',
                                                    borderRadius: '50%'
                                                }} title={user.session_token ? 'Utilisateur actif' : 'Utilisateur inactif'}></div>
                                            </div>

                                            {/* Nom et Prénom */}
                                            <div style={{flex: 1}}>
                                                <p style={{margin: 0, fontSize: 13, fontWeight: 500, color: '#222'}}>
                                                    {user.prenom && user.nom ? `${rescueHtml(user.prenom)} ${rescueHtml(user.nom)}` : 'Sans nom'}
                                                </p>
                                            </div>

                                            {/* Email */}
                                            <div style={{flex: 1.2}}>
                                                <p style={{margin: 0, fontSize: 12, color: '#666'}}>
                                                    {user.email ? rescueHtml(user.email) : '-'}
                                                </p>
                                            </div>

                                            {/* Rang */}
                                            <div style={{flex: 0.15, textAlign: 'center'}}>
                                                <span style={{
                                                    display: 'inline-block',
                                                    backgroundColor: '#f0f0f0',
                                                    padding: '3px 8px',
                                                    borderRadius: 3,
                                                    fontSize: 11,
                                                    fontWeight: 'bold',
                                                    color: '#666'
                                                }}>
                                                    {user.id_type_users == '1' ? 'SL' : user.id_type_users == '2' ? 'Admin' : user.id_type_users == '3' ? 'User' : ''}
                                                </span>
                                            </div>

                                            {/* Checkbox Visualisation */}
                                            <div style={{flex: 0.3, display: 'flex', justifyContent: 'center'}}>
                                                <input
                                                    type="checkbox"
                                                    checked={operation && operation.id_users_droits_visu && operation.id_users_droits_visu.split(';').includes(user.id) ? true : false}
                                                    onChange={async(e) => {
                                                        if (operation && operation.id_users_droits_visu && operation.id_users_droits_visu.split(';').includes(user.id)) {
                                                            let arr_visu = operation.id_users_droits_visu ? operation.id_users_droits_visu.split(';') : [];
                                                            arr_visu = arr_visu.filter(id => id !== user.id);
                                                            operation.id_users_droits_visu = arr_visu.join(';');
                                                            let arr_modif = operation.id_users_droits_modif ? operation.id_users_droits_modif.split(';') : [];
                                                            arr_modif = arr_modif.filter(id => id !== user.id);
                                                            operation.id_users_droits_modif = arr_modif.join(';');
                                                        } else {
                                                            if (operation && operation.id_users_droits_visu && operation.id_users_droits_visu !== '') {
                                                                operation.id_users_droits_visu = operation.id_users_droits_visu + ';' + user.id;
                                                            } else {
                                                                operation.id_users_droits_visu = user.id;
                                                            }
                                                        }
                                                        var tmp = operation;
                                                        await setOperation(tmp);
                                                        var params = {
                                                            'update': true,
                                                            'id_users_droits_visu': tmp.id_users_droits_visu,
                                                            'id_users_droits_modif': tmp.id_users_droits_modif,
                                                            'id': tmp.id
                                                        };
                                                        await axios.post("https://app-slfinance.fr/api/operations.php", qs.stringify(params))
                                                        await setAff(!aff);
                                                    }}
                                                    style={{cursor: 'pointer', width: 18, height: 18}}
                                                />
                                            </div>

                                            {/* Checkbox Modification */}
                                            <div style={{flex: 0.3, display: 'flex', justifyContent: 'center'}}>
                                                <input
                                                    type="checkbox"
                                                    checked={operation && operation.id_users_droits_modif && operation.id_users_droits_modif.split(';').includes(user.id) ? true : false}
                                                    onChange={async(e) => {
                                                        if (operation && operation.id_users_droits_modif && operation.id_users_droits_modif.split(';').includes(user.id)) {
                                                            let arr_modif = operation.id_users_droits_modif ? operation.id_users_droits_modif.split(';') : [];
                                                            arr_modif = arr_modif.filter(id => id !== user.id);
                                                            operation.id_users_droits_modif = arr_modif.join(';');
                                                        } else {
                                                            if (operation && operation.id_users_droits_visu && !operation.id_users_droits_visu.split(';').includes(user.id)) {
                                                                if (operation && operation.id_users_droits_visu && operation.id_users_droits_visu !== '') {
                                                                    operation.id_users_droits_visu = operation.id_users_droits_visu + ';' + user.id;
                                                                }
                                                            }
                                                            if (operation && operation.id_users_droits_modif && operation.id_users_droits_modif !== '') {
                                                                operation.id_users_droits_modif = operation.id_users_droits_modif + ';' + user.id;
                                                            } else {
                                                                operation.id_users_droits_modif = user.id;
                                                            }
                                                        }
                                                        var tmp = operation;
                                                        await setOperation(tmp);
                                                        var params = {
                                                            'update': true,
                                                            'id_users_droits_visu': tmp.id_users_droits_visu,
                                                            'id_users_droits_modif': tmp.id_users_droits_modif,
                                                            'id': tmp.id
                                                        };
                                                        await axios.post("https://app-slfinance.fr/api/operations.php", qs.stringify(params))
                                                        await setAff(!aff);
                                                    }}
                                                    style={{cursor: 'pointer', width: 18, height: 18}}
                                                />
                                            </div>
                                        </div>
                                    )) : (
                                        <div style={{padding: 40, textAlign: 'center', color: '#999'}}>
                                            <p>Aucun utilisateur disponible</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        :null}

                    </div>
                    :
                    <div style={{textAlign: 'center', marginTop: 50}}>
                        <p>Chargement...</p>
                    </div>
                    }
                </div>

            </Access>
        </div>
    );
}

export default OperationPage;
